(function (ws) {
    'use strict';

    ws.views.quoteTableEstimatedFreightView = ws.views.modal.extend({
        /**
         * Extend default events
         */
        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .qut-estimate-freight-submit': 'updateEstimatedFreight'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            this.eventAgg.on('renderEstimatedFreighOverlay', this.renderEstimatedFreighOverlay, this);
            this.$button = this.$('.qut-estimate-freight-submit');
            this.$cancel = this.$('.qut-estimate-freight-cancel');
            ws.views.modal.prototype.initialize.call(this);
        },

        /**
         * Render Modal
         * @param {string} target
         */
        renderEstimatedFreighOverlay: function(target, freight, message) {
            this.eventAgg.trigger(this.$el.attr('id'));
            this.$button.attr('data-update', target);
            this.$button.attr('data-freight', freight);
            this.$button.attr('data-message', message);
            this.$cancel.attr('id', target);
        },

        /**
         * On cancel revere the updated field value
         *
         */
        closeModal: function () {
            this.eventAgg.trigger('triggerClose:' + this.$cancel.attr('id'));

            // Trigger super closeModal
            ws.views.modal.prototype.closeModal.call(this);
        },

        /**
         * This method will update EstimateFreight
         */
        updateEstimatedFreight: function (e) {
            this.eventAgg.trigger('triggerUpdateCall:' + e.target.dataset.update, e.target.dataset.freight, e.target.dataset.message ? e.target.dataset.message : true);
            ws.views.modal.prototype.closeModal.call(this);
        }
    });
})(westcon);
